// ============================================
// WISHLISTPAGE.JS - Página de wishlist
// Ruta: /wishlist
// ============================================

import React from "react";
import { useNavigate } from "react-router-dom";
import { useWishlist } from "../context/WishlistContext";
// import { useCart } from "../context/CartContext";
import SEO from "../components/SEO";
import "./WishlistPage.css";

// Ícono X para eliminar
const RemoveIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="14" height="14">
    <path d="M18 6L6 18M6 6l12 12" strokeLinecap="round" />
  </svg>
);

export default function WishlistPage() {
  const navigate = useNavigate();
  const { wishlistItems, removeFromWishlist, wishlistCount } = useWishlist();

  return (
    <div className="wl-root" data-header-theme="light">
      <SEO title="Lista de deseos" description="Tu wishlist Physiology Skincare Co." noindex />
      <div className="wl-container">

        {/* Header */}
        <div className="wl-header">
          <h1 className="wl-title">
            Wishlist
            {wishlistCount > 0 && (
              <span className="wl-count">{wishlistCount}</span>
            )}
          </h1>
          {wishlistCount > 0 && (
            <p className="wl-subtitle">
              {wishlistCount} {wishlistCount === 1 ? "producto guardado" : "productos guardados"}
            </p>
          )}
        </div>

        {/* Estado vacío */}
        {wishlistItems.length === 0 ? (
          <div className="wl-empty">
            <div className="wl-empty-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" width="48" height="48">
                <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" />
              </svg>
            </div>
            <p className="wl-empty-text">Tu wishlist está vacía</p>
            <p className="wl-empty-desc">Guarda tus productos favoritos para encontrarlos fácilmente.</p>
            <button className="wl-empty-btn" onClick={() => navigate("/shop")}>
              Explorar productos
            </button>
          </div>
        ) : (
          <>
            {/* Grid de productos */}
            <div className="wl-grid">
              {wishlistItems.map((item, index) => (
                <div
                  key={item.id}
                  className="wl-card"
                  style={{ animationDelay: `${Math.min(index, 7) * 0.07}s` }}
                >
                  {/* Botón X eliminar */}
                  <button
                    className="wl-remove-btn"
                    onClick={() => removeFromWishlist(item.id)}
                    aria-label="Eliminar de wishlist"
                  >
                    <RemoveIcon />
                  </button>

                  {/* Imagen */}
                  <div
                    className="wl-card-img"
                    onClick={() => navigate(`/products/${item.handle || item.id}`)}
                  >
                    {item.image ? (
                      <img src={item.image} alt={item.name} />
                    ) : (
                      <div className="wl-card-img-placeholder" />
                    )}
                  </div>

                  {/* Info */}
                  <div className="wl-card-body">
                    <p
                      className="wl-card-name"
                      onClick={() => navigate(`/products/${item.handle || item.id}`)}
                    >
                      {item.name}
                    </p>
                    {item.price && (
                      <p className="wl-card-price">
                        ${item.price?.toLocaleString()}
                      </p>
                    )}

                    {/* Botón agregar al carrito */}
                    <button
                      className="wl-add-btn"
                      onClick={() => navigate(`/products/${item.handle || item.id}`)}
                    >
                      Ver producto
                    </button>
                  </div>
                </div>
              ))}
            </div>

            {/* Footer acciones */}
            <div className="wl-footer">
              <button className="wl-continue-btn" onClick={() => navigate("/shop")}>
                Seguir explorando
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
